import React, { useCallback, useEffect, useState } from 'react';
import { useT } from '@repo/common';
import JobBoardPagination from '../../JobBoard/JobBoardPagination';
import UserRow from './UserRow';
import { getAdminUsers } from '../../../api/user/user.api';

const PAGE_SIZE = 12;

const UserList = ({ filter, keyword, onActionSuccess, onActionFailed }) => {
  const t = useT();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  // 필터·검색어가 바뀌면 첫 페이지부터 다시 본다
  useEffect(() => {
    setCurrentPage(1);
  }, [filter, keyword]);

  const fetchUsers = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await getAdminUsers({
        page: currentPage - 1,
        size: PAGE_SIZE,
        keyword,
        filter,
      });
      setUsers(data.content || []);
      setTotalPages(data.totalPages || 1);
      setTotalCount(data.totalElements ?? 0);
    } catch (error) {
      console.error('회원 목록을 불러오지 못했습니다.', error);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, keyword, filter]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleUpdated = (message) => {
    onActionSuccess?.(message);
    fetchUsers();
  };

  return (
    // 표 머리글이 있는 tabletV 이상에서만 머리글 아래 띠(-mt-5)와 겹친다
    <div className='w-full min-w-0 flex flex-col justify-between rounded-[20px] tabletV:rounded-[30px] overflow-hidden px-2 pt-4 pb-10 bg-grayscale-gray00 gap-10 tabletV:-mt-5 relative z-10 min-h-[400px] tabletV:min-h-[664px]'>
      <div className='flex flex-col gap-2'>
        {isLoading ? (
          <div className='w-full p-10 flex justify-center text-text-placeholder typo-b14 h-[400px] tabletV:h-[664px]'>
            {t('Loading...', '불러오는 중...')}
          </div>
        ) : users.length === 0 ? (
          <div className='w-full p-10 flex items-center justify-center text-text-placeholder typo-b14 h-[400px] tabletV:h-[664px]'>
            <div className='pb-6'>
              {keyword
                ? t('No users match your search', '검색 결과가 없습니다')
                : t('No users yet', '아직 회원이 없습니다')}
            </div>
          </div>
        ) : (
          <>
            <div className='px-2 pb-2 typo-b12 text-text-placeholder'>
              {t(`${totalCount} users`, `${totalCount}명`)}
            </div>
            {users.map((user) => (
              <UserRow
                key={user.id}
                user={user}
                onUpdated={handleUpdated}
                onFailed={onActionFailed}
              />
            ))}
          </>
        )}
      </div>

      <JobBoardPagination
        isMyPage
        current={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default UserList;
